import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { CouponUsageState } from "models/couponUsage";

const initialState: CouponUsageState = {
  loading: false,
  data: {},
  message: "",
  success: false,
};

const couponUsageSlice = createSlice({
  name: "couponUsage",
  initialState,
  reducers: {
    getCouponUsage(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getCouponUsageSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getCouponUsageFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
    },
  },
});

//Actions
export const couponUsageAction = couponUsageSlice.actions;

//Selectors
export const getCouponUsageData = (state: RootState) => state.couponUsage.data;
export const selectIsLoading = (state: RootState) => state.couponUsage.loading;

//Reducers
const couponUsageReducer = couponUsageSlice.reducer;
export default couponUsageReducer;
